<template>
	<div
		:id="id"
		class="artist-list"
		:class="{ 'artist-list--featured': !!featuredTag }"
	>
		<div class="artist-list__title" v-if="sectionTitle">
			{{ sectionTitle }}
		</div>
		<div class="artist-list__content">
			<Artist
				v-for="b in artists"
				:key="b.id"
				:fields="b.fields"
				:tag="featuredTag"
			></Artist>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const featuredTag = computed(() => props.fields?.featuredTag?.value);
const artists = computed(() => props.fields?.artists);
const sectionTitle = computed(() => props.fields?.sectionTitle?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.artist-list {
	scroll-margin-top: calc(var(--header-height, 54px) + var(--spacing-2, 16px));
	margin-top: var(--spacing-3, 24px);
	margin-bottom: var(--spacing-3, 24px);
}

.artist-list__title {
	padding: var(--spacing-2, 16px) var(--spacing-2, 16px) 0
		var(--spacing-2, 16px);
	color: var(--primary-color, #fff);
	font-size: var(--text-xl, 24px);
	font-weight: 900;
	line-height: 120%;
	text-transform: uppercase;
}

.artist-list:not(.artist-list--featured):not(.artist-list--one-column)
	.artist-list__content {
	display: flex;
	flex-wrap: wrap;
	gap: var(--spacing-1, 8px);
	padding-top: var(--spacing-2, 16px);

	.artist {
		width: calc(50% - 4px);
	}
}

.artist-list--one-column .artist {
	margin: var(--spacing-1, 8px) 0;
}
</style>
